let projectsData: { name: string, thumbnail: string, tagline: string, deployed?: string, repo?: string, login?: string}[] = 
    [
        {
            name: "Destination: Banana",
            thumbnail: '/assets/project-thumbs/destination-banana-thumb.png',
            tagline: "Follow the wikipedia rabbit hole on a quest to reach the ultimate destination: BANANA!",
            deployed: 'https://destination-banana.vercel.app/',
            repo: 'https://github.com/cOdeBedient/destination-banana'
        },
        {
            name: "Prove-it!",
            thumbnail: '/assets/project-thumbs/prove-it-thumb.png',
            tagline: 'Arguing with a friend about how tall Kareem Abdul Jabbar is? Let a robot "prove" your point.',
            deployed: 'https://prove-it-coral.vercel.app/',
            repo: 'https://github.com/cOdeBedient/prove-it'
        },
        {
            name: "Up & A w a y",
            thumbnail: '/assets/project-thumbs/up-and-away-thumb.png',
            tagline: "Organize and book trips on this vanilla JavaScript app.",
            deployed: 'https://codebedient.github.io/Up-and-A-w-a-y/',
            repo: 'https://github.com/cOdeBedient/Up-and-A-w-a-y',
            login: 'username: traveler18 | pw: traveler'
        },
        {
            name: "bLOOMbABY",
            thumbnail: '/assets/project-thumbs/bloom-baby-thumb.png',
            tagline: "EXPERIMENTAL. Plant a 3D flower and watch it grow. Will you breed the next superflower?",
            deployed: 'https://bloombabyfe-toms-projects-be041e30.vercel.app/',
            repo: 'https://github.com/2311-capstone-bloom-brothers/bloom-brothers-fe'
        },
        // {
        //     name: "Look at This Snake",
        //     thumbnail: '/assets/project-thumbs/look-at-this-snake-thumb.png',
        //     tagline: "The sight of snakes makes you crawl in your skin? This dog will help to desensitize you.",
        //     deployed: 'https://look-at-this-snake-v2.vercel.app/',
        //     repo: 'https://github.com/cOdeBedient/look-at-this-snake-v2'
        // },

        // {
        //     name: "Rancid Tomatillos",
        //     thumbnail: '/assets/project-thumbs/rancid-tomatillos-thumb.png',
        //     tagline: "A React interface for organizing and selecting movies.",
        //     deployed: 'https://rancid-tomatillos-kappa.vercel.app/',
        //     repo: 'https://github.com/cOdeBedient/rancidTomatillos'
        // }
    ]

export default projectsData